import React from 'react'
import PropType from 'prop-types'
import { v4 as uuid } from 'uuid'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'

function BaseSelect({
  className,
  defaultLabel,
  disabled,
  inputLabel,
  items,
  onChange,
  required,
  textColor,
  value,
}) {
  const useStyles = makeStyles({
    root: {
      minWidth: '100%',
      marginTop: '10px',
    },
    select: {
      color: textColor,
    },
  })
  const classes = useStyles()
  return (
    <FormControl
      className={className}
      classes={{ root: classes.root }}
      required={required}
      variant="outlined"
      disabled={disabled}
    >
      <InputLabel htmlFor={`${inputLabel}${uuid()}`}>{inputLabel}</InputLabel>
      <Select
        classes={{ select: classes.select }}
        value={value}
        onChange={onChange ? (event) => onChange(event.target.value) : () => null}
        labelWidth={inputLabel.length * 8}
        inputProps={{
          name: inputLabel,
          id: `${inputLabel}${uuid()}`,
          style: { whiteSpace: 'inherit' },
        }}
      >
        { !!defaultLabel && (
          <MenuItem value="">
            <em>{defaultLabel}</em>
          </MenuItem>
        )}
        {(items || []).map((item) => (
          <MenuItem value={item.value} key={item.label}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

BaseSelect.defaultProps = {
  className: '',
  defaultLabel: '',
  disabled: false,
  inputLabel: '',
  onChange: null,
  required: false,
  textColor: '#000',
  value: '',
}

BaseSelect.propTypes = {
  className: PropType.string,
  defaultLabel: PropType.string,
  disabled: PropType.bool,
  inputLabel: PropType.string,
  items: PropType.arrayOf(
    PropType.object,
  ).isRequired,
  onChange: PropType.func,
  required: PropType.bool,
  textColor: PropType.string,
  value: PropType.oneOfType([PropType.string, PropType.number, PropType.bool]),
}

export default BaseSelect
